import React from 'react'; 
import { connect } from 'react-redux';

import classes from './NearbyList.scss';

const nearbyList = (props) => {
     console.log(props.importantLandmarks);
     let places = [];
     if(props.popularLandmarks) {
          places = places.concat(props.popularLandmarks);
     }
     console.log(places);
     if(props.importantLandmarks) {
          places = places.concat(props.importantLandmarks);
     }

     console.log(places);

     const placesJSX = places.map((place, index) => {
          return (
               <li key={index} className={`${classes.ListItem} u-flex justify-content-between`}>
                    <p className={`u-textColorNormal u-noWrapWithEllipsis pr-1`}>{place.L}</p>
                    <span className={`u-textColorLight u-width70 u-textAlignRight`}>{place.D}</span>
               </li>
          );
     })

     return (
          <ul className={`${classes.List} u-flex f-wrap justify-content-between pl-7 pr-7 phone-f-column phone-p-0`}>
               {placesJSX}
          </ul>
     );
}

const mapStateToProps = state => {
     return {
          importantLandmarks: state.hotels.importantLandmarks,
          popularLandmarks: state.hotels.popularLandmarks
     }
}

export default connect(mapStateToProps)(nearbyList);


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelNearby/NearbyList/NearbyList.js